import { useAuth } from "@/contexts/AuthContext";

export const useModuleAccess = () => {
  const { userRole, profile } = useAuth();
  const allowedModules = Array.isArray(profile?.allowed_modules)
    ? profile.allowed_modules
    : null;
  const temporaryModules = Array.isArray(profile?.temporary_allowed_modules)
    ? profile.temporary_allowed_modules
    : [];
  const temporaryAccessUntil = profile?.temporary_access_until
    ? new Date(profile.temporary_access_until)
    : null;
  const hasActiveTemporaryAccess =
    temporaryModules.length > 0 &&
    temporaryAccessUntil !== null &&
    !Number.isNaN(temporaryAccessUntil.getTime()) &&
    temporaryAccessUntil.getTime() > Date.now();

  const canAccessModule = (moduleId?: string) => {
    if (!moduleId) return true;
    if (userRole === "admin" || userRole === "supervisor") return true;
    if (!allowedModules) return true;
    if (allowedModules.includes(moduleId)) return true;
    if (hasActiveTemporaryAccess) {
      return temporaryModules.includes(moduleId);
    }
    return false;
  };

  return {
    allowedModules,
    hasCustomAccess: Array.isArray(profile?.allowed_modules),
    temporaryModules,
    temporaryAccessUntil,
    hasActiveTemporaryAccess,
    canAccessModule,
  };
};
